/* @flow */
/* eslint no-unused-vars: 0 */

import React from "react"

class ProductPagination extends React.PureComponent {
  constructor(props) {
    super(props);

    this.calculateFirstProduct = this.calculateFirstProduct.bind(this);
    this.calculateLastProduct = this.calculateLastProduct.bind(this);
    this.goToPage = this.goToPage.bind(this);

    this.state = {
      number_of_pages: 0,
      first_product: 0,
      last_product: this.props.products_total,
      pagination_links_to_show: props.mobile === true ? 4 : 5,
      page_input_error: false,
      first_page: props.current_page,
      last_page: props.current_page + props.mobile === true ? 4 : 5
    };
  }

  componentWillReceiveProps(nextProps) {
    let first_page = nextProps.current_page;
    let last_page = first_page + this.state.pagination_links_to_show;
    this.setState({
      first_product: this.calculateFirstProduct(nextProps),
      last_product: this.calculateLastProduct(nextProps),
      number_of_pages: this.calculateNumberOfPages(nextProps),
      first_page,
      last_page
    });
  }

  calculateFirstProduct(props) {
    return (props.current_page - 1) * props.per_page + 1;
  }

  calculateLastProduct(props) {
    if (props.per_page > props.products_total) {
      return props.products_total;
    } else {
      var total = this.calculateFirstProduct(props) + this.props.per_page - 1;
      if (total < props.products_total) {
        return total;
      } else {
        return props.products_total;
      }
    }
  }

  calculateNumberOfPages(props) {
    return Math.ceil(props.products_total / this.props.per_page);
  }

  goToPage(e) {
    if (e.key === 'Enter') {
      var inputNumber = parseInt(e.target.value);
      if (inputNumber >= 1 && inputNumber <= this.state.number_of_pages) {
        this.props.setPage(inputNumber, true);
        this.setState({
          page_input_error: false
        });
      } else {
        this.setState({
          page_input_error: true
        });
      }
    }
  }

  render() {
    const {
      chevron_left: chevronLeft,
      chevron_right: chevronRight
    } = this.props.assets.icons;
    let paginationLinks = [];
    let display_first_link = true;
    let display_last_link = true;

    if (this.props.products_total >= 1) {
      paginationLinks = [...Array(this.state.pagination_links_to_show)].map(
        (x, page) => {
          page += this.props.current_page - 2;
          if (page >= 1) {
            if (
              page <= this.state.number_of_pages ||
              page <=
                this.state.number_of_pages - this.state.pagination_links_to_show
            ) {
              if (page === 1) {
                display_first_link = false;
              }
              if (page === this.state.number_of_pages) {
                display_last_link = false;
              }
              if (page >= 1) {
                return (
                  <a
                    className={
                      'pagination--link ' +
                      (this.props.current_page == page ? 'selected' : '')
                    }
                    href="#"
                    key={page}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.setPage(page, true);
                    }}
                  >
                    {page}
                  </a>
                );
              }
            }
          }
        }
      );
    }

    const first_link =
      this.props.current_page !== 1 && display_first_link ? (
        <a
          className="pagination--link"
          href="#"
          key={'first-link'}
          onClick={(e) => {
            e.preventDefault();
            this.props.setPage(1, true);
          }}
        >
          1 ..
        </a>
      ) : (
        ''
      );

    const last_link =
      this.props.current_page !== this.state.number_of_pages &&
      display_last_link ? (
        <a
          className="pagination--link"
          href="#"
          key={'last-link'}
          onClick={(e) => {
            e.preventDefault();
            this.props.setPage(this.state.number_of_pages, true);
          }}
        >
          .. {this.state.number_of_pages}
        </a>
      ) : (
        ''
      );
    const default_page = this.props.current_page;

    return (
      <div className="row-fluid">
        <div className="pagination--links span8">
          <a
            className="pagination--link"
            href="#"
            key={'previous-link'}
            onClick={(e) => {
              e.preventDefault();
              if (this.props.current_page > 1) {
                this.props.setPage(this.props.current_page - 1, true);
              }
            }}
          >
            <img src={chevronLeft} alt="" height={21} width={20} />
          </a>

          {first_link}

          {paginationLinks}

          {last_link}

          <a
            className="pagination--link"
            href="#"
            key={'next-link'}
            onClick={(e) => {
              e.preventDefault();
              if (this.props.current_page !== this.state.number_of_pages) {
                this.props.setPage(this.props.current_page + 1, true);
              }
            }}
          >
            <img src={chevronRight} alt="" height={21} width={20} />
          </a>
          <div className="pagination--go-to-page hidden-phone">
            Page{' '}
            <input
              type="text"
              defaultValue={default_page}
              className={
                this.state.page_input_error === true ? ' input--error' : ''
              }
              onKeyPress={this.goToPage}
            />
          </div>
        </div>
        <div className="pagination--summary span4">
          Displaying Products{' '}
          <b>
            {this.state.first_product} - {this.state.last_product}
          </b>{' '}
          of <b>{this.props.products_total}</b> in total
        </div>
      </div>
    );
  }
}

export default ProductPagination;
